export default __webpack_public_path__ + "static/media/rumdrinks.bea15b3a.png";